import { adminPageShellSx } from "../../Shared/AdminPageHeader";

export const contentPageShellSx = adminPageShellSx;

export const contentPageTitleSx = {
  mb: 2,
  fontWeight: "bold",
  color: "#0b3d87",
  textAlign: "center",
};

export const contentTabsSx = {
  mb: 3,
  borderBottom: 1,
  borderColor: "divider",
  "& .MuiTab-root": { fontWeight: 600, textTransform: "none" },
  "& .Mui-selected": { color: "#0b3d87" },
  "& .MuiTabs-indicator": { backgroundColor: "#0b3d87" },
};

export const CONTENT_CANVAS_BG = "#f8fafc";
export const CONTENT_MENUBAR_BG = "#f5f5f5";
export const CONTENT_ACCENT = "#0b3d87";

export const contentSectionPaperSx = {
  p: 0,
  borderRadius: 1.5,
  backgroundColor: CONTENT_CANVAS_BG,
  boxShadow: "none",
  border: "1px solid #e2e8f0",
  overflow: "hidden",
  width: "100%",
  boxSizing: "border-box",
};

export const contentSectionMenubarSx = {
  position: "static",
  backgroundColor: CONTENT_MENUBAR_BG,
  maxHeight: 56,
  color: "inherit",
  boxShadow: "none",
  borderBottom: "1px solid #e2e8f0",
  borderRadius: 0,
};

export const CONTENT_TOOLBAR_MIN_HEIGHT = 40;

export const contentSectionMenubarToolbarSx = {
  gap: 0.75,
  flexWrap: "wrap",
  alignItems: "center",
  minHeight: CONTENT_TOOLBAR_MIN_HEIGHT,
  py: 1,
  px: 1,
  "@media (min-width: 0px)": {
    minHeight: CONTENT_TOOLBAR_MIN_HEIGHT,
  },
  "@media (min-width: 600px)": {
    minHeight: CONTENT_TOOLBAR_MIN_HEIGHT,
  },
  "& .MuiOutlinedInput-root": {
    minHeight: 32,
  },
  "& .MuiInputBase-root": {
    fontSize: "0.875rem",
  },
  "& .MuiButton-root": {
    minHeight: 32,
  },
  "& .MuiIconButton-root": {
    p: 0.5,
  },
};

export const contentSectionMenubarTitleSx = {
  fontSize: "0.75rem",
  fontWeight: 700,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: "#64748b",
  whiteSpace: "nowrap",
};

export const contentSectionBodySx = {
  p: 1,
  flex: 1,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  gap: 1,
  boxSizing: "border-box",
  backgroundColor: CONTENT_CANVAS_BG,
};

export const contentPanelInsetSx = {
  pl: 1,
  pt: 1,
  pb: 1,
  pr: 0,
  mr: 1,
  boxSizing: "border-box",
};

/** Wrapper under panel menubar: no padding, clips overflow for nested scroll/fill layouts. */
export const contentPanelBodyShellSx = {
  ...contentSectionBodySx,
  p: 0,
  gap: 0,
  overflow: "hidden",
};

/** Scroll container; scrollbar sits on the panel edge (pair with contentPanelScrollInnerSx). */
export const contentPanelScrollSx = {
  flex: 1,
  minHeight: 0,
  overflow: "auto",
  overflowX: "hidden",
};

/** Padded inner region inside a panel scroll area. */
export const contentPanelScrollInnerSx = {
  ...contentPanelInsetSx,
  minHeight: "min-content",
  display: "flex",
  flexDirection: "column",
  gap: 1,
};

/** Fill-height shell for custom layouts (e.g. sticky footer); children own inset/scroll. */
export const contentPanelFillShellSx = {
  flex: 1,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

/** Fill-height inset body for viewport tables and similar full-height panels. */
export const contentPanelFillInsetSx = {
  ...contentPanelFillShellSx,
  ...contentPanelInsetSx,
  gap: 0,
};

/** Sticky action footer aligned with panel content inset. */
export const contentPanelStickyFooterSx = {
  ...contentPanelInsetSx,
  pt: 1,
  display: "flex",
  justifyContent: "flex-end",
  flexShrink: 0,
};

export const contentTablePaginationFooterSx = {
  display: "flex",
  justifyContent: "center",
  p: 1.5,
  borderTop: "1px solid #e2e8f0",
  flexShrink: 0,
  bgcolor: "#fff",
};

export const contentBodyCardsStackSx = {
  display: "flex",
  flexDirection: "column",
  gap: 1,
  width: "100%",
  minWidth: 0,
  maxWidth: "100%",
  boxSizing: "border-box",
};

export const contentPrimaryButtonSx = {
  bgcolor: CONTENT_ACCENT,
  borderRadius: 1,
  "&:hover": { bgcolor: "#092f6a" },
};

export const contentEditorCardSx = {
  borderRadius: 1.5,
  border: "1px solid #e8edf3",
  boxShadow: "none",
  height: "100%",
  backgroundColor: "#fff",
};

export const contentCardContentSx = {
  p: 1.5,
  "&:last-child": { pb: 1.5 },
};

export const contentSectionTitleSx = {
  mb: 2,
  fontWeight: 700,
  fontSize: "0.875rem",
  color: "#0b3d87",
};

export const contentSectionHeadingSx = {
  ...contentSectionMenubarTitleSx,
  mb: 0,
};

export const contentCompactToolbarSx = {
  width: "100%",
};

export const contentFieldSx = {
  maxWidth: "100%",
  minWidth: 0,
  "& .MuiOutlinedInput-root": {
    borderRadius: 1,
    backgroundColor: "#fff",
    minHeight: 40,
    "& fieldset": { borderColor: "#87b5e3 !important" },
    "&:hover fieldset": { borderColor: "#1976d2 !important" },
    "&.Mui-focused fieldset": {
      borderColor: "#0b3d87 !important",
      borderWidth: "1px",
    },
  },
  "& .MuiInputLabel-root": { fontSize: "0.875rem" },
};

export const contentRichEditorSx = {
  minHeight: 120,
  maxHeight: 360,
  overflowY: "auto",
  overscrollBehavior: "contain",
  p: 1.25,
  borderRadius: 0,
  border: "none",
  borderTop: "1px solid #e8edf3",
  backgroundColor: "#fff",
  fontSize: "0.9375rem",
  lineHeight: 1.55,
  color: "#1f2937",
  outline: "none",
  boxSizing: "border-box",
  maxWidth: "100%",
  tabSize: 4,
  MozTabSize: 4,
  "&:focus": {
    boxShadow: "inset 0 0 0 2px rgba(11, 61, 135, 0.08)",
  },
};

export const contentArticleParagraphToolbarSx = {
  px: 1,
  py: 0.75,
  borderBottom: "1px solid #e2e8f0",
  backgroundColor: CONTENT_MENUBAR_BG,
  borderRadius: "6px 6px 0 0",
  "& .MuiToggleButton-root": {
    borderColor: "#cbd5e1",
    px: 0.85,
  },
  "& .MuiToggleButton-root.Mui-selected": {
    bgcolor: "#dbeafe",
    color: CONTENT_ACCENT,
    borderColor: "#93c5fd",
  },
  "& .MuiOutlinedInput-root": {
    minHeight: 32,
    bgcolor: "#fff",
  },
  "& .MuiInputBase-root": {
    fontSize: "0.8125rem",
  },
};

export const contentArticleParagraphEditorShellSx = {
  border: "1px solid #e8edf3",
  borderRadius: 1,
  overflow: "hidden",
  backgroundColor: "#fff",
};

export const contentArticleParagraphEditorSx = {
  ...contentRichEditorSx,
  minHeight: 800,
  maxHeight: 800,
  overflowY: "auto",
  [`& [data-wcp-line-align]`]: {
    display: "block",
    minHeight: "1.55em",
    lineHeight: 1.55,
    tabSize: 4,
    MozTabSize: 4,
    whiteSpace: "pre-wrap",
  },
  [`& [data-wcp-tab="1"]`]: {
    display: "inline-block",
    width: "4ch",
    minWidth: "4ch",
    whiteSpace: "pre",
    verticalAlign: "baseline",
  },
};

export const contentGestioneGridSx = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", lg: "minmax(240px, 0.9fr) minmax(0, 2fr)" },
  gap: 1.5,
  alignItems: "stretch",
};

export const contentBannerGridSx = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", lg: "1fr 3fr" },
  gap: 1.5,
  alignItems: "stretch",
};

export const contentViewportPanelSx = (height) => ({
  height,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  minHeight: 0,
});

export const contentViewportGridFillSx = {
  flex: 1,
  minHeight: 0,
  alignItems: "stretch",
};

export const contentViewportSectionPaperSx = {
  ...contentSectionPaperSx,
  height: "100%",
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};


export const contentFillTableContainerSx = (loading) => ({
  flex: 1,
  minHeight: 0,
  borderRadius: 2,
  border: "1px solid #e0e0e0",
  backgroundColor: "white",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  opacity: loading ? 0.6 : 1,
  transition: "opacity 0.3s",
});

export const BANNER_IMAGE_ACCEPT = ".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp";
export const BANNER_IMAGE_UPLOAD_TOOLTIP = "Formati accettati: JPG, PNG, WEBP";
